var Backbone = require('backbone');

var helpScreenTpl = require('../templates/help-screen.jade');

module.exports = Backbone.View.extend({
	el: helpScreenTpl(),
	events: {
		'click .overlay': 'remove'
	},
	autoRender: true,
	initialize: function () {
		if (this.autoRender) this.render();
	},
	render: function () {
		return this;
	}
});


// WEBPACK FOOTER //
// ./app/views/help-screen.js